import React from "react";

export const RefundCard = ({
  heading,
  description,
  onClick,
  isChecked = false,
  isShowCredit,
  itemID,
  productDetailsState,
  refundSettingsState,
  minus_charges,
  get_extra,
  store_credit,
}) => {
  return (
    <label className={`radio-component  ${isChecked && "active"}`}>
      <h2 className="heading_refund_return_card">{heading}</h2>
      {itemID === 1 ? (
        isShowCredit && (
          <div className="item_content_main">
            <p className="item_choose__text">
              {get_extra} {productDetailsState.currency}
              {
                refundSettingsState?.incentive?.return_refund_store_credits
                  ?.refund_value?.additional_store_credits
              }{" "}
              {store_credit}
            </p>
          </div>
        )
      ) : (
        <div className="saara-d-none item_content_main">
          <p className="item_choose__text">
            {productDetailsState.currency}
            {
              refundSettingsState?.incentive?.return_refund_store_credits
                ?.refund_value?.additional_store_credits
            }{" "}
            {minus_charges}
          </p>
        </div>
      )}
      <p className="description">{description}</p>
      <div className="radio-container">
        <input
          className="refund_option_radio radio_option"
          name="refund_radio"
          type="radio"
          onClick={onClick}
          checked={isChecked}
        />
      </div>
    </label>
  );
};
